import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import React = require('react');
import { FeatureFlags } from '../../ts/FeatureFlags';
import { UserSettingsHelper } from '../UserSettingsHelper';
import { MarkAnimationProps,MarkAnimationSetting } from './MarkAnimation';
import { StartPageSetting } from './StartPageSetting';
import { WelcomeBanner, WelcomeBannerProps } from './WelcomeBanner';
export interface PreferenceSettingProps {
  startPage: string;
  isViewerSelf: boolean;
  isViewerAdmin: boolean;
  serverUser: IServerUserInfo;
  welcomeChannelEnabled: boolean;
  userHasNoSiteId: boolean;
  siteUser: ISiteUserInfo;
  isServerUserSubplace?: boolean;
  sessionSiteUrlName: string;
}

export function PreferenceSettings(props: PreferenceSettingProps): JSX.Element{
  const startPageSectionProps = {
    startPage: props.startPage,
    isViewerSelf: props.isViewerSelf,
    isViewerAdmin: props.isViewerAdmin,
    sessionSiteUrlName: props.sessionSiteUrlName,
    serverUser: props.serverUser,
  };

  const welcomeBannerProps = {
    initialValues: {welcomeChannelEnabled: props.welcomeChannelEnabled}
  };

  const markAnimationProps = {
    userHasNoSiteId: props.userHasNoSiteId,
    siteUser: props.siteUser,
    serverUser: props.serverUser
  };

  return (
    <>
    <h2 className={UserSettingsStyle.titleText}>{Messages.userSettings_Preference_Header()}</h2>
    <table>
      <tbody>
        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={2}>
            <StartPageSetting {...startPageSectionProps}/>
          </td>
        </tr>
        {!props.isServerUserSubplace &&
          getWelcomeAndAnimationSettings(welcomeBannerProps, markAnimationProps, props)
        }
      </tbody>
    </table>
    </>
  );

}

function getWelcomeAndAnimationSettings(welcomeBannerProps: WelcomeBannerProps, markAnimationProps: MarkAnimationProps, props: PreferenceSettingProps) {
  return (
    <>
      {UserSettingsHelper.getSectionDividerLine()}
      <tr>
        <td className={UserSettingsStyle.tbody} colSpan={2}>
          <WelcomeBanner {...welcomeBannerProps} />
        </td>
      </tr>
      {UserSettingsHelper.getSectionDividerLine()}
      {props.isViewerSelf && FeatureFlags.markAnimationServer &&

        <tr>
          <td className={UserSettingsStyle.tbody} colSpan={2}>
            <MarkAnimationSetting {...markAnimationProps} />
          </td>
        </tr>}
      {props.isViewerSelf && FeatureFlags.markAnimationServer && UserSettingsHelper.getSectionDividerLine()}
    </>
  );
}